@if (error(); as basketError) { @if (basketError.errors; as errors) { @for (error of errors; track error) {
<div [class]="cssClass()" data-testing-id="basket-errors">
  <p>{{ error.message }}</p>
  @if (error.causes; as causes) { @for (cause of causes; track cause) {
  <p role="alert">
    <span> {{ cause.message }}</span>
    @if (cause.parameters?.sku) {
    <span class="product-id"
      ><br />
      <span class="product-id-label">{{ 'product.itemNumber.label' | translate }}</span>
      <span itemprop="sku">{{ cause.parameters.sku }}</span>
    </span>
    }
  </p>
  } }
</div>
} } }
